import React, { useEffect } from "react";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import { useDetail, useQuery } from "seed/gql";
import { usePost } from "seed/api";
import { Loading } from "seed/helpers";
import { useUserUsage } from "components/util/helpers/UserUsage";
import l from "components/util/l";
import View from "components/presentation/forms/flows/FlowEditForm.view";


function FlowFormEdit({ match,
  onEdit = () => setTimeout(() => { window.location.reload() }, 50),
  onDelete = () => window.location.replace("/app") }) {

  const { flowId = null } = match.params;
  const userId = sessionStorage.getItem("id");
  const historyRouter = useHistory();
  const { userUsage } = useUserUsage();
  const isDeveloper = sessionStorage.getItem("is_developer") == "true";

  const [callUpdate] = usePost("/flows/edit_flow", {
    onCompleted: () => {
      historyRouter.goBack();
      onEdit(flowId);
    }
  });

  const [callDelete, reqDelete] = usePost("/flows/delete_flow", {
    onCompleted: () => {
      historyRouter.goBack();
      onDelete(flowId)
    }
  })

  const reqUsers = useQuery(`{
    users {
      firstName
      lastName
      email
    }
  }`)

  const reqFolders = useQuery(`{
    folders {
      name
    }
  }`, `user.id = ${userId}`, { orderBy: "name" });

  const reqFlows = useQuery(`{
    flows {
      id
      name
    }
  }`, `user.id = ${userId} AND is_active=true AND is_current_version=true`, { orderBy: "name" });

  const reqFlow = useDetail(`{
    flow { 
      name
      settings
      token
      description
      isTemplate
      templateName
      templateType
      templateCategories {
        name
        description
        uiSettings
      }
      folder { 
        id 
        user { id }
      }
      user { id }
      parent { id }
    }
  }`, flowId);

  const reqTemplateCategories = useQuery(`{
    templateCategories {
      name
      description
      uiSettings
    }
  }`, "", { orderBy: "name" });

  useEffect(() => {
    reqFlow.refetch();
    reqFlows.refetch();
    reqFolders.refetch();
  }, []);

  const onSubmit = (values) => {
    const newValues = {
      flow_id: flowId,
      name: values.name,
      owner_id: values.owner,
      parent_id: values.parent_id,
      description: values.description ?? "",
      settings: { ...flow.settings, }
    }

    if (values.folder != "0")
      newValues.folder = parseInt(values.folder);

    if (isDeveloper) {
      newValues.is_template = values?.is_template ?? false;
      newValues.template_name = values?.template_name ?? values?.name ?? "";
      newValues.template_settings = values?.template_settings ?? {};
      newValues.template_categories = values?.template_categories ?? [];
      newValues.template_type = values?.template_type ?? "USE_CASE";
    }
    callUpdate(newValues);
  }

  const onClickDelete = () => {
    swal({
      title: l("Eliminar solución%SB036"),
      icon: "warning",
      text: l("¿Estás seguro que desea eliminar la solución?%SB037"),
      buttons: {
        confirm: {
          text: l("Aceptar%GA020"),
          className: "swal-button swal-button--cancel btn-success",
        },
        cancel: l("Cancelar%GA021"),
      },
    }).then((response) => {
      if (response) {
        callDelete({ flow_id: flow.id });
      }
    })
  }

  if (reqFlow.loading || reqFolders.loading || reqTemplateCategories.loading || reqUsers.loading) return <Loading />;
  if (reqFlow.error || reqFolders.error || reqTemplateCategories.error || reqUsers.error) return "Error";

  const { flow = {} } = reqFlow.data;
  const { flows = [] } = reqFlows.data;
  const { folders = {} } = reqFolders.data;
  const { users = [] } = reqUsers.data;
  const { templateCategories = [] } = reqTemplateCategories.data;
  const folder = flow.folder?.find(folder => folder.user.id == userId);

  const initialValues = {
    name: flow.name,
    folder: folder?.id ?? "null",
    owner: flow.user?.id,
    description: flow.description,
    show_animations: flow.settings.show_animations,
    show_pagination: flow.settings.show_pagination,
    is_template: flow?.isTemplate ?? false,
    template_name: flow?.templateName ?? "",
    template_categories: flow?.templateCategories.map(category => category.id) ?? [],
    template_type: flow?.templateType ?? "",
    parent_id: flow?.parent?.id
  }

  return (
    <View
      templateCategories={templateCategories}
      initialValues={initialValues}
      userUsage={userUsage}
      flow={flow}
      flows={flows}
      users={users}
      folders={folders}
      isEditing={true}
      isDeveloper={isDeveloper}
      historyRouter={historyRouter}
      onSubmit={onSubmit}
      onClickDelete={onClickDelete}
    />
  );
}

export default FlowFormEdit;